export const isBrowserContext = (): boolean => typeof window !== "undefined";
